import { Component, OnInit, Input, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationService } from 'primeng/api';
import { SalesPlanImagesVm, SalesPlanImageFilesVm } from '../../../models/salesplan-vm';
import { v4 as uuidv4 } from 'uuid';
import { ProjectService } from '../../../services/project.service';
import { ProjectConstants } from '../../../constants/component-messages';
import { UnsavedChangesService } from '../../../../unsaved-changes.service';

@Component({
  selector: 'app-imageupload',
  templateUrl: './imageupload.component.html',
  styleUrls: ['./imageupload.component.css']
})
export class ImageuploadComponent implements OnInit {

  @Input() salesplanImages: SalesPlanImagesVm = new SalesPlanImagesVm();
  @Output() emitValueChanged = new EventEmitter<SalesPlanImagesVm>();
  @Input() disableAfterReview: boolean = false;

  selectedFile: any[] = [];
  IsImagesLoaded: boolean = false;

  constructor(private projectService: ProjectService, private toastrService: ToastrService, 
    private confirmationService: ConfirmationService, private unsavedChangesService:UnsavedChangesService
  ) { }

  ngOnInit(): void {
  }
  onAnyFieldValueChange(e:boolean){
    if(e){
      this.unsavedChangesService.setUnsavedChanges(true);
    }
  }

  changeFile(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64 = (reader.result as string).split(',')[1]; // Remove data URL prefix
        resolve(base64);
      };
      reader.onerror = () => reject('Error reading file');
      reader.readAsDataURL(file);
    });
  }

  multiFileEvent(event: any) {
    if (event.target.value) {

      let totalImages = 0;
      if(this.salesplanImages.imageFiles! !=null
        && this.salesplanImages.imageFiles! != undefined
        && this.salesplanImages.imageFiles!.length >0
      )
      {
        totalImages = this.salesplanImages.imageFiles!.length + event.target.files.length;
      }
      else{
        totalImages = event.target.files.length;
      }

      if (totalImages > 5) {
        this.toastrService.error("Upload image field allows upto 5 images.");
        return;
      }

      const allowedTypes = ['image/png', 'image/jpeg'];
      // extension check is required because JFIF shares the image/jpeg MIME type
      const allowedExtensions = ['.png', '.jpg', '.jpeg'];
      const maxSizeBytes = 5 * 1024 * 1024; // 5 MB

      for (var i = 0; i < event.target.files.length; i++) {
        const file = event.target.files[i] as File;
        const ext = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();

        if (!allowedTypes.includes(file.type) || !allowedExtensions.includes(ext)) {
          this.toastrService.error(`"${file.name}" is not a supported format. Only PNG and JPG/JPEG files are allowed.`);
          return;
        }

        if (file.size > maxSizeBytes) {
          this.toastrService.error(`"${file.name}" exceeds the maximum allowed size of 5 MB.`);
          return;
        }
      }

      if (event.target.files.length > 0) {
        var counter = 0;
        if (this.salesplanImages.imageFiles === null || this.salesplanImages.imageFiles === undefined || this.salesplanImages.imageFiles ?.length == 0) {
          this.salesplanImages.imageFiles = new Array<SalesPlanImageFilesVm>;
        }
        for (var i = 0; i < event.target.files.length; i++) {
          const file = event.target.files[i] as File;
          this.changeFile(file).then((base64: any) => {
            let imageVm = new SalesPlanImageFilesVm();
            imageVm.base64Bytes = base64.substr(base64.indexOf(',') + 1);
            imageVm.imageName = file.name;
            imageVm.type = file.type;
            imageVm.tempUniqueId = this.generateUniqueId();

            this.salesplanImages.imageFiles ?.push(imageVm);
            counter = counter + 1;
          });
        }
      }
      this.unsavedChangesService.setUnsavedChanges(true);
      this.emitValueChanged.emit(this.salesplanImages);
    }

  }

  generateUniqueId(): string {
    return uuidv4();
  }

  delItem(salesPlanImageFilesVm: SalesPlanImageFilesVm) {

    if(!this.disableAfterReview){
      let imageIndex: number = -1;

      if (salesPlanImageFilesVm.imageID !== 0) {
        imageIndex = this.salesplanImages.imageFiles ?.findIndex(file => file.imageID === salesPlanImageFilesVm ?.imageID);
  
        this.confirmationService.confirm({
          header: ProjectConstants.SALESPLAN_DELETE_HEADER,
          message: ProjectConstants.SALESPLAN_DELETE_IMAGES,
          accept: () => {
  
            this.projectService.deleteSalesPlanImages(salesPlanImageFilesVm.salesPlanID, salesPlanImageFilesVm ?.imageID, "main").subscribe(data => {
  
              this.salesplanImages.imageFiles.splice(imageIndex, 1);
              this.toastrService.success(ProjectConstants.SALESPLAN_DELETE_IMAGE_SUCCESS);
            });
          }
        });
      }
      else {
        if (salesPlanImageFilesVm?.tempUniqueId !== undefined) {
          imageIndex = this.salesplanImages.imageFiles ?.findIndex(file => file.tempUniqueId === salesPlanImageFilesVm?.tempUniqueId);
          this.salesplanImages.imageFiles.splice(imageIndex, 1);
        }
      }
    }
  }

}
